import { ChangeCircleRounded, ArrowBack } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Button, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import {
  GetApiConvertedFilesApiResponse,
  useGetApiConvertedFilesQuery,
  useGetApiUploadedFilesQuery,
  usePostApiConvertTusFileMutation,
} from "src/app/services/api.generated";
import { ConvertedFilesData } from "src/components/entities/convertedFiles/tables/convertedFilesData";
import TableSkeletonRow from "src/components/molecule/TableSkeletonRow";
import DataTable from "src/components/organization/DataTable";

function ConvertedFiles() {
  const params = useParams();
  const {
    data: convertedFiles,
    isLoading,
    refetch,
  } = useGetApiConvertedFilesQuery(params.tusFileId || "");

  const { data: uploadedFiles } = useGetApiUploadedFilesQuery();

  const [enhancedData, setEnhancedData] = useState<
    GetApiConvertedFilesApiResponse[]
  >([]);

  const [convertFile, { isLoading: convertFileIsLoading }] =
    usePostApiConvertTusFileMutation();

  useEffect(() => {
    if (uploadedFiles) {
      const uploadedFile = uploadedFiles.find(
        (x) => x.tus_file_id === params.tusFileId
      );

      if (uploadedFile) {
        if (uploadedFile.file_status !== 2) {
          toast.error("فایل هنوز به طور کامل آپلود نشده است");
          navigate("/files/uploaded-files");
        }
      } else {
        toast.error("شناسه فایل یافت نشد");
        navigate("/files/uploaded-files");
      }
    }
  }, [uploadedFiles]);

  const navigate = useNavigate();
  useEffect(() => {
    if (convertedFiles) {
      setEnhancedData(
        convertedFiles.map((x) => {
          return {
            ...x,
            folderName: x.tus_file_id,
            file_status:
              x.file_status === 1
                ? "در حال پردازش" :
                "تکمیل شده"

          } as GetApiConvertedFilesApiResponse;
        })
      );
    }
  }, [convertedFiles]);

  if (isLoading) {
    return <TableSkeletonRow title="فایل های تبدیل شده" cellCount={4} />;
  } else {
    return (
      <>
        <Stack
          sx={{ width: "100%" }}
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="center"
          columnGap={1}
          rowGap={1}
        >
          {/* <BreadCrumbs spaceBottom={false} /> */}
          <Stack
            columnGap={1}
            rowGap={1}
            alignItems="center"
            direction={{ xs: "column", sm: "row" }}
          >
            <LoadingButton
              sx={{ fontFamily: "tahoma" }}
              startIcon={<ChangeCircleRounded />}
              variant="contained"
              color="secondary"
              loading={convertFileIsLoading}
              onClick={() =>
                convertFile({
                  tusFileId: params.tusFileId || "",
                  bitrate: "500k",
                  quality: "842:480",
                })
              }
            >
              Convert to 842:480-500k
            </LoadingButton>
            <LoadingButton
              sx={{ fontFamily: "tahoma" }}
              startIcon={<ChangeCircleRounded />}
              variant="contained"
              color="secondary"
              loading={convertFileIsLoading}
              onClick={() =>
                convertFile({
                  tusFileId: params.tusFileId || "",
                  bitrate: "1000k",
                  quality: "1280:720",
                })
              }
            >
              Convert to 1280:720-1000k
            </LoadingButton>
            <LoadingButton
              sx={{ fontFamily: "tahoma" }}
              startIcon={<ChangeCircleRounded />}
              variant="contained"
              color="secondary"
              loading={convertFileIsLoading}
              onClick={() =>
                convertFile({
                  tusFileId: params.tusFileId || "",
                  bitrate: "2000k",
                  quality: "1920:1080",
                })
              }
            >
              Convert to 1920:1080-2000k
            </LoadingButton>
          </Stack>
          <Stack direction="row" columnGap={1} rowGap={1} alignItems="center">
            <Button
              startIcon={<ArrowBack />}
              variant="contained"
              onClick={() => navigate("/files/uploaded-files")}
            >
              بازگشت
            </Button>
          </Stack>
        </Stack>
        <br />
        <DataTable
          rows={enhancedData}
          columns={ConvertedFilesData}
          title={"فایل های تبدیل شده"}
          pathname={"/files/converted-files"}
        />
      </>
    );
  }
}

export default ConvertedFiles;
